import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import { FormattedMessage } from 'react-intl';

import get from 'lodash.get';
import classNames from 'classnames';

import StorefrontSectionHeader from './StorefrontSectionHeader';

import styles from './styles/StorefrontArticleSection.scss';

function getArticle(hasArticle, articleUrl, articleLabel, isPreview) {
    if (hasArticle && articleUrl && articleLabel) {
        if (isPreview) {
            return <p className={styles.article}>{articleLabel}</p>;
        }
        return (
            <a className={styles.article} href={articleUrl}>
                {articleLabel}
            </a>
        );
    }
    return null;
}

function getArticles(seller, isPreview) {
    const hasShopTalk = get(seller, 'sellerPreferences.hasShopTalk');
    const shopTalkUrl = get(seller, 'sellerPreferences.shopTalkUrl');
    const shopTalkLabel = get(seller, 'sellerPreferences.shopTalkLabel');

    const hasOther = get(seller, 'sellerPreferences.hasOther');
    const otherUrl = get(seller, 'sellerPreferences.otherUrl');
    const otherLabel = get(seller, 'sellerPreferences.otherLabel');

    return {
        Other: getArticle(hasOther, otherUrl, otherLabel, isPreview),
        ShopTalk: getArticle(hasShopTalk, shopTalkUrl, shopTalkLabel, isPreview),
    };
}

function StorefrontArticleSection({ isPreview, seller }) {
    const { ShopTalk, Other } = getArticles(seller, isPreview);
    const className = classNames(styles.section, {
        [styles.noArticles]: !ShopTalk && !Other,
    });

    return (
        <section className={className}>
            {/* Content */}
            <div className={styles.content}>
                {/* Header */}
                <StorefrontSectionHeader
                    header={
                        <FormattedMessage
                            id="StorefrontArticleSection.header"
                            defaultMessage="More about this seller"
                        />
                    }
                />
                {ShopTalk}
                {Other}
            </div>
        </section>
    );
}

StorefrontArticleSection.propTypes = {
    isPreview: PropTypes.bool.isRequired,
    seller: PropTypes.object.isRequired,
};

export default createFragmentContainer(StorefrontArticleSection, {
    seller: graphql`
        fragment StorefrontArticleSection_seller on Seller {
            sellerPreferences {
                hasShopTalk
                shopTalkUrl
                shopTalkLabel
                hasOther
                otherUrl
                otherLabel
            }
        }
    `,
});
